import instanceFrag from "./Instance";
import consignmentFrag from "./Consignment";
import entity from "./Entity";

const ConsignmentWork = ({ instance = true, user = false, grossProfit = false } = {}) => `
  id
  artistNames
  conPrice
  consignment {
    ${consignmentFrag({
      channel: true,
      company: { consignmentTerms: false, loanTerms: false },
      consigner: true,
      contact: true,
      currency: true,
      exhibition: true,
      registrar: false,
      salesUser: true,
      status: true,
      type: true,
      terms: false,
    })}
  }
  consignmentId
  discount
  discountRate
  fabCost
  fabRate
  ${grossProfit ? "grossProfit" : ""}
  instanceId
  ${
    instance
      ? `instance {
      ${instanceFrag(instance)}
    }`
      : ""
  }
  price
  ref
  share
  updatedAt
  ${
    user
      ? `user {
      ${entity}
    }`
      : ""
  }
`;

export default ConsignmentWork;
